import React from "react";
import { ButtonHTMLAttributes } from "react";
import styled from "styled-components";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "success" | "error";
  mode?: "container" | "outline" | "text";
  children: React.ReactNode;
  styleHover?: React.CSSProperties;
}

const StyledButton = styled.button<
  Omit<ButtonProps, "styleHover"> & { $styleHover?: React.CSSProperties }
>`
  padding: 10px 20px;
  font-size: 1.2em !important;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;

  border: ${({ mode, theme, variant }) =>
    mode === "outline" ? `2px solid ${theme[variant || "button"]}` : "none"};
  background-color: ${({ mode, theme, variant }) =>
    mode === "container" ? theme[variant || "button"] : "transparent"};
  color: ${({ mode, theme, variant }) =>
    mode === "container" ? "#fff" : theme[variant || "button"]};

  &:hover {
    background-color: ${({ $styleHover, mode, theme, variant }) =>
      $styleHover?.backgroundColor ||
      (mode === "container"
        ? theme.secondaryBackground
        : theme[variant || "button"])} !important;
    color: ${({ $styleHover, mode }) =>
      $styleHover?.color ||
      (mode === "container" ? "#fff" : "#000")} !important;
    border: ${({ $styleHover, mode }) =>
      $styleHover?.border ||
      (mode === "outline" ? "2px solid transparent" : "none")};
  }
`;

const Button: React.FC<ButtonProps> = ({ children, styleHover, ...props }) => {
  const { variant, mode, ...rest } = props;
  return (
    <StyledButton
      variant={variant}
      mode={mode}
      $styleHover={styleHover}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
